module.exports = __webpack_public_path__ + "img/btn_left_d.04c03483.png";